<document-editor *ngIf="config!==null"
                 id="docxForComments"
                 documentServerUrl="{{officeUrl}}"
                 [config]="config"
                 [events_onDocumentReady]="onDocumentReady"
                 height="100%"
                 width="100%"
></document-editor>
